var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9974 0.00162652C14.6353 -0.00484713 7.07252 7.57064 7.05861 16.9438C7.05218 21.1936 8.78712 24.824 11.4021 27.9198C16.1709 33.5656 20.3433 39.5106 22.6213 46.646C22.8271 47.2902 23.1334 48.0218 24.0136 47.9995C24.9713 47.9752 25.2287 47.1553 25.456 46.4613C27.5938 39.9324 31.1653 34.2917 35.6786 29.1694C38.3614 26.1244 40.5128 22.6158 40.8738 18.4946C41.7539 8.45106 33.8648 -0.135773 23.9974 0.00162652Z",
    fill: "url(#paint0_linear_2614_49238)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5553 18.4949C15.522 18.5118 15.5206 18.5427 15.5515 18.5633L18.383 20.4338L19.1941 16.6169L15.5553 18.4949Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3198 16.6157H31.6039C31.5669 16.6157 31.5092 16.6298 31.476 16.6466L27.8873 18.4956C27.854 18.5124 27.8526 18.5434 27.8836 18.5635L30.6677 20.396C30.6991 20.4162 30.7544 20.433 30.7919 20.433H31.5074C31.5444 20.433 31.5495 20.4162 31.5191 20.396L28.6773 18.526L32.3269 16.6457C32.3601 16.6298 32.3569 16.6157 32.3198 16.6157Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7871 16.6157H25.7989L24.9883 20.434H29.9756C30.0126 20.434 30.0177 20.4171 29.9868 20.397L27.1497 18.527L30.7941 16.6466C30.8274 16.6298 30.8241 16.6157 30.7871 16.6157Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8517 16.6157H33.1358C33.0983 16.6157 33.0411 16.6298 33.0079 16.6466L29.4192 18.4956C29.3864 18.5124 29.385 18.5434 29.4154 18.5635L32.1996 20.396C32.2305 20.4162 32.2867 20.433 32.3238 20.433H33.0397C33.0767 20.433 33.0819 20.4162 33.051 20.396L30.2092 18.526L33.8587 16.6457C33.8925 16.6298 33.8892 16.6157 33.8517 16.6157Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5657 14.1177H18.8228C18.1673 14.1177 17.7086 14.53 17.6003 15.0398C17.5408 15.3195 17.6472 15.5683 17.8627 15.7389L22.0821 18.5244L22.0853 18.523L22.0858 18.5244L30.5737 14.1486C30.6065 14.1317 30.6032 14.1177 30.5657 14.1177Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7025 22.8949L22.0851 18.5247L22.0842 18.5261L22.0814 18.5247L16.6775 21.3112C16.3898 21.4808 16.1781 21.73 16.1185 22.0102C16.0094 22.5191 16.2924 22.9319 16.9484 22.9319H28.6913C28.7288 22.9324 28.7334 22.9155 28.7025 22.8949Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2614_49238",
    x1: 23.9998,
    y1: 0,
    x2: 23.9998,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E62A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59C28"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.049a2b5ea108937b10e7b436a770ee8e.svg";
export { ForwardRef as ReactComponent };